import IconButton from '@mui/material/IconButton';
import { toastr } from 'react-redux-toastr';
import AccountBalanceOutlinedIcon from '@mui/icons-material/AccountBalanceOutlined';
import Modal from '@material-ui/core/Modal';
import { Button } from '@mui/material';
import API from '../../../../create/api';
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import * as helper from '../../../../../helper/index';
import Tooltip from '@mui/material/Tooltip';
import Box from '@mui/material/Box';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

interface AddtoBalanceProps {
  id: number;
  addToBalance: boolean;
  updateParcel: (id: number, data: object) => void;
}

export default function AddtoBalance({ id, addToBalance, updateParcel }: AddtoBalanceProps) {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = React.useState(false);

  const handleClose = () => {
    setModalOpen(false);
  };

  const addToBalanceAction = async () => {
    setModalOpen(false);
    await API.update(`${process.env.REACT_APP_API_SERVER}/parcels`, id, { addToBalance: true })
      .then((res) => {
        toastr.success('Parcel Updated', `Parcel ID:${id ?? ''} Add to Balance`);
        updateParcel(id, { addToBalance: true });
      })
      .catch((error) => {
        helper.axiosErrorHandling(error);
      });
  };

  return (
    <>
      <Modal
        aria-labelledby="spring-modal-title"
        aria-describedby="spring-modal-description"
        className={classes.modal}
        open={modalOpen}
        onClose={handleClose}
        closeAfterTransition
        BackdropProps={{
          timeout: 500,
        }}
      >
        <div className={classes.paper}>
          <h1 id="spring-modal-title">Add to Balance</h1>
          <p id="spring-modal-description">
            Do you want to Add to Balance {id}
            <br />
            <Button color="secondary" onClick={addToBalanceAction}>
              Yes
            </Button>
            <Button color="primary" onClick={handleClose}>
              No
            </Button>
          </p>
        </div>
      </Modal>
      <Tooltip
        title={addToBalance ? 'COD received' : 'Mark as balance received after COD collection by the courier.'}
        arrow
      >
        {addToBalance ? (
          <IconButton>
            <AccountBalanceOutlinedIcon fontSize="small" style={{ color: '#979797' }} />
          </IconButton>
        ) : (
          <IconButton
            onClick={() => {
              setModalOpen(true);
            }}
          >
            <AccountBalanceOutlinedIcon fontSize="small" style={{ color: '#2e7d32' }} />
          </IconButton>
        )}
      </Tooltip>
    </>
  );
}
